import { Dialog, DialogTitle, IconButton } from '@mui/material';
import React from 'react';
import Loading from '../../../Components/Loading';
import CloseIcon from '@mui/icons-material/Close';
import FullScreenView from '../../../Components/FullScreenView';
import { notify } from '../../../Utils/toastify';
import { getFileNameFromAWSURL } from '../../../Utils/constantData';

function PreviewDialog({
  previewDoc,
  handleClose,
}: {
  previewDoc: any;
  handleClose: () => void;
}) {
  const [imgLoading, setImageLoading] = React.useState(true);
  const [isFullView, setIsFullView] = React.useState(false);

  const isImage = /\.(jpg|jpeg|png|gif|heic)$/i.test(previewDoc?.name);
  const isPDF = /\.pdf$/i.test(previewDoc?.name);
  const isVideo = /\.(mp4|mov|webm)$/i.test(previewDoc?.name);

  const toggleFullscreen = () => {
    setIsFullView(!isFullView);
  };

  const handleDownload = (URL: string) => {
    // setDownloadLoader(true);

    fetch(URL)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.blob();
      })
      .then(blob => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = getFileNameFromAWSURL(URL);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // setDownloadLoader(false);
      })
      .catch(error => {
        console.error('Download failed:', error);
        notify('Unable to download the document.', 'error');
        // setDownloadLoader(false);
      });
  };

  return (
    <>
      <Dialog
        open={!!previewDoc}
        onClose={() => {
          handleClose();
          setImageLoading(true);
        }}
        maxWidth="md"
        fullWidth
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        <DialogTitle>
          <div className="modal-title d-flex align-center flex-between">
            <p>Preview File</p>
            <div>
              {' '}
              <button
                title="full Screen"
                onClick={toggleFullscreen}
                className="blank-btn"
              >
                <i className="full-screen-icon"></i>
              </button>
              {/* <button
                title="full Screen"
                onClick={() => handleDownload(previewDoc?.url)}
                className="blank-btn"
              >
                <i className="download-icon"></i>
              </button> */}
              <IconButton onClick={handleClose} size="small">
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </DialogTitle>

        {previewDoc && (
          <div
            style={{
              position: 'relative',
              padding: '16px',
              textAlign: 'center',
            }}
          >
            {/* Image Preview */}
            {isImage && (
              <>
                {imgLoading && (
                  <div style={{ width: '800px' }}>
                    <Loading type="div" height="full" />
                  </div>
                )}
                <img
                  src={previewDoc.url}
                  alt={previewDoc.name}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '80vh',
                    display: imgLoading ? 'none' : 'block',
                  }}
                  onLoad={() => setImageLoading(false)}
                />
              </>
            )}

            {/* PDF Preview */}
            {isPDF && (
              <embed
                src={previewDoc.url}
                type="application/pdf"
                width="800px"
                height="600px"
              />
            )}

            {/* Video Preview */}
            {isVideo && (
              <video
                src={previewDoc.url}
                controls
                autoPlay
                style={{ maxWidth: '100%', maxHeight: '80vh' }}
              />
            )}
          </div>
        )}
      </Dialog>
      {isFullView ? (
        <FullScreenView
          doc={previewDoc.url}
          setIsFullView={setIsFullView}
          isFullView={isFullView}
          onClose={handleClose}
        />
      ) : null}
    </>
  );
}

export default PreviewDialog;
